import { Component } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';

@Component({
    selector: 'fi-media-bank-confirm-delete-list-item-uses',
    templateUrl: './media-bank-confirm-delete-list-item-uses.component.html',
    styleUrls: ['./media-bank-confirm-delete-list-item-uses.component.scss'],
    standalone: false,
})
export class MediaBankConfirmDeleteListItemUsesComponent extends ItemsListRowItemBase {
    isUsesExpanded: boolean = false;

    onShowUsesClick($event: MouseEvent) {
        $event.preventDefault();
        this.isUsesExpanded = !this.isUsesExpanded;
        this.itemsListRowComponent.events$.next({
            event: 'onShowUsesClick',
            data: this.isUsesExpanded,
        });
    }
}
